import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import BlueBox from './BlueBox'
import * as Helpers from './helpers'
import NoResults from './NoResults'
import { Arrow, Padding } from '..'
import { colors } from '../../constants'

const Header = styled.div`
    font-size: 15px;
    height: 20%;
    opacity: 0.8;

    ${({ hoverable }) =>
        hoverable &&
        `
      &:hover {
        cursor: pointer;
        font-weight: bold;
        margin-top: 2px;
        margin-bottom: -2px;
      }
    `}
`

const HeaderIcon = styled(FontAwesomeIcon)`
    color: ${colors.grey};
    margin-left: 5px;

    div:hover > & {
        color: ${colors.white};
        cursor: pointer;
    }
`

const Body = styled.div`
  align-items: flex-end;
  display: flex;
  height: 80%;
  justify-content: space-between;
  width 100%;
`

const Value = styled.div`
    font-size: 30px;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 5%;

    &:not(:only-child) {
        margin-right: 15px;
    }

    @media (max-height: 1220px) {
        font-size: 20px;
    }
`

const IconWrapper = styled.div`
    display: inline-block;
    height: 70px;
    min-width: auto;

    @media (max-height: 1220px) {
        height: 50px;
    }

    & > img {
        height: 100%;
        width: auto;
        filter: opacity(0.5) drop-shadow(0 0 0 ${colors.bluelighter});
    }
`

const InfoBox = ({ delta, isEmpty, loading, onClickHeader, title, value, img, noFooter }) => (
    <BlueBox loading={loading} noFooter={noFooter} noResults={isEmpty}>
        <Padding fullHeight>
            <Header hoverable={onClickHeader} onClick={onClickHeader}>
                {title}
                {onClickHeader && <HeaderIcon icon="random" />}
            </Header>
            <Body>
                {isEmpty && <NoResults />}
                {!isEmpty && (
                    <Fragment>
                        <Value title={value}>
                            {value}
                            {delta ? (
                                <Fragment>
                                    &nbsp;
                                    <Arrow colored direction={Helpers.transformDeltaToKey(delta)} />
                                </Fragment>
                            ) : null}
                        </Value>
                        {img && (
                            <IconWrapper>
                                {typeof img === 'string' && <img src={img} alt="" />}
                                {typeof img !== 'string' && img}
                            </IconWrapper>
                        )}
                    </Fragment>
                )}
            </Body>
        </Padding>
    </BlueBox>
)

InfoBox.propTypes = {
    delta: PropTypes.number,
    isEmpty: PropTypes.bool,
    loading: PropTypes.bool,
    onClickHeader: PropTypes.func,
    title: PropTypes.string,
    value: PropTypes.string,
    img: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    noFooter: PropTypes.bool,
}

InfoBox.defaultProps = {
    delta: null,
    isEmpty: true,
    loading: false,
    onClickHeader: null,
    title: '',
    value: '',
    img: null,
    noFooter: false,
}

export default InfoBox
